import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-343d8b41")

_pushScopeId("data-v-343d8b41")
const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "kn-material-input-label" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = {
  key: 1,
  class: "p-m-2"
}
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = {
  key: 2,
  class: "p-mx-2 p-mt-3"
}
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-mx-2 p-mt-3" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = {
  key: 3,
  class: "p-mx-2 p-mt-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_FunctionsCatalogDatasetFormColumnsTable = _resolveComponent("FunctionsCatalogDatasetFormColumnsTable")
  const _component_FunctionsCatalogDatasetFormVariablesTable = _resolveComponent("FunctionsCatalogDatasetFormVariablesTable")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_FunctionsCatalogDatasetEnvironmentTable = _resolveComponent("FunctionsCatalogDatasetEnvironmentTable")
  const _component_Card = _resolveComponent("Card")
  const _component_FunctionsCatalogParametersForm = _resolveComponent("FunctionsCatalogParametersForm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      id: "form-container",
      class: "p-m-2"
    }, {
      content: _withId(() => [
        _createVNode(_component_Accordion, {
          class: "p-m-2",
          activeIndex: 0
        }, {
          default: _withId(() => [
            _createVNode(_component_AccordionTab, {
              header: _ctx.$t('common.description')
            }, {
              default: _withId(() => [
                _createVNode("div", null, [
                  _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('common.description')), 1),
                  _createVNode("p", {
                    innerHTML: _ctx.selectedFunction.description
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }),
        (_ctx.selectedFunction.benchmarks)
          ? (_openBlock(), _createBlock(_component_Accordion, {
              key: 0,
              class: "p-m-2"
            }, {
              default: _withId(() => [
                _createVNode(_component_AccordionTab, {
                  header: _ctx.$t('managers.functionsCatalog.benchmarks')
                }, {
                  default: _withId(() => [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.functionsCatalog.benchmarks')), 1),
                      _createVNode("p", {
                        innerHTML: _ctx.selectedFunction.benchmarks
                      }, null, 8, ["innerHTML"])
                    ])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.selectedFunction.inputColumns.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.functionsCatalog.columnsSettings')), 1),
              _createVNode(_component_FunctionsCatalogDatasetFormColumnsTable, {
                columns: _ctx.selectedFunction.inputColumns,
                datasetColumns: _ctx.datasetColumns
              }, null, 8, ["columns", "datasetColumns"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedFunction.inputVariables.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.functionsCatalog.variablesSettings')), 1),
              _createVNode(_component_FunctionsCatalogDatasetFormVariablesTable, {
                variables: _ctx.selectedFunction.inputVariables
              }, null, 8, ["variables"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_8, [
          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.environment')), 1),
          _createVNode(_component_Dropdown, {
            class: "kn-material-input",
            modelValue: _ctx.selectedEnvironment,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedEnvironment = $event)),
            options: _ctx.selectedFunction.language == 'Python' ? _ctx.pythonEnvironments : _ctx.rEnvironments,
            optionLabel: "label",
            optionValue: "label",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('environmentSelected', _ctx.selectedEnvironment)))
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.selectedEnvironment)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_FunctionsCatalogDatasetEnvironmentTable, { libraries: _ctx.libraries }, null, 8, ["libraries"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.selectedDataset.pars.length > 0)
      ? (_openBlock(), _createBlock(_component_FunctionsCatalogParametersForm, {
          key: 0,
          id: "parameters-form",
          class: "p-m-2",
          propParameters: _ctx.selectedDataset.pars
        }, null, 8, ["propParameters"]))
      : _createCommentVNode("", true)
  ]))
})